import { render, staticRenderFns } from "./BarcodeStyleEditor.vue?vue&type=template&id=5b0ba824&scoped=true&"
import script from "./BarcodeStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./BarcodeStyleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BarcodeStyleEditor.vue?vue&type=style&index=0&id=5b0ba824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ba824",
  null
  
)

export default component.exports